import FirmwareTemplate from './firmware.html';

export default angular
  .module('main.devices.edit.tabs.firmware', [])

  .directive('editDeviceFirmwareTab', () => {
    return {
      restrict: 'E',
      template: FirmwareTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $interval,
                   utils,
                   I18nService,
                   EditDeviceDataProvider) => {
        const FIRMWARE_VERSION = 'firmware';
        const FIRMWARE_UPDATE_STATUS = 'firmwareUpdateStatus';

        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.locale = I18nService.getLocale();

        angular.extend($scope, {
          helpers: {},
          back: back,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.deviceInfoResource.init(),
            $scope.dataProvider.firmwareGroupsResource.init(),
            $scope.dataProvider.deviceCurrentMeasurementsResource.init(),
          ])
            .then(() => {
              $scope.loading = false;
              initViewModel();
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function initViewModel() {
          const device = angular.copy($scope.dataProvider.deviceInfoResource.value);
          const deviceMeasurements = angular.copy($scope.dataProvider.deviceCurrentMeasurementsResource.value);

          if (deviceMeasurements.parameters?.length > 0) {
            let firmwareVersion = deviceMeasurements.parameters.find(el => el.name === FIRMWARE_VERSION);
            let firmwareUpdateStatus = deviceMeasurements.parameters.find(el => el.name === FIRMWARE_UPDATE_STATUS);
            $scope.helpers.firmwareVersion = firmwareVersion.value;
            $scope.helpers.firmwareUpdateStatus = firmwareUpdateStatus.value;
          }

          $scope.firmwareGroups = angular.copy($scope.dataProvider.firmwareGroupsResource.value);
          $scope.deviceFirmwareGroup = device.device.fwGroupId;
        }

        function back() {
          $scope.dataProvider.activeTab = 'parameters';
        }

      }
    };
  })
  .name;
